import { render } from "./hot.vue?vue&type=template&id=67dfd40c&scoped=true&ts=true"
import script from "./hot.vue?vue&type=script&lang=ts"
export * from "./hot.vue?vue&type=script&lang=ts"

import "./hot.vue?vue&type=style&index=0&id=67dfd40c&lang=less"
import "./hot.vue?vue&type=style&index=1&id=67dfd40c&lang=less&scoped=true"
import "./hot.vue?vue&type=style&index=2&id=67dfd40c&lang=less"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67dfd40c"]])

export default __exports__